module.exports = __webpack_public_path__ + "media/images/img/banner/bnr_special_contents_001-7e9459955cdf17c6464c25ba04016a20.jpg";